import { render, staticRenderFns } from "./DynamicTableAsync.vue?vue&type=template&id=3bb08a7d&scoped=true&"
import script from "./DynamicTableAsync.vue?vue&type=script&lang=ts&"
export * from "./DynamicTableAsync.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb08a7d",
  null
  
)

export default component.exports